import { render, staticRenderFns } from "./ComplieRightMenuPerSon.vue?vue&type=template&id=62abcf26&scoped=true"
import script from "./ComplieRightMenuPerSon.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenuPerSon.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenuPerSon.vue?vue&type=style&index=0&id=62abcf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62abcf26",
  null
  
)

export default component.exports